import {useState, useEffect} from "react";

const useTableInspectionItemsScroll = (tableRef, items, hasResultOk=true) => {
  const [maxHeight, setMaxHeight] = useState(null);

  useEffect(() => {
    if (!tableRef.current || !items) return;
    const filteredItems = !hasResultOk ? items.filter(item => !item.result) : items;
    if (filteredItems.length < 11) return;

    const thead = tableRef.current.querySelector("thead");
    const theadHeight = thead ? thead.offsetHeight : 0;

    const rows = tableRef.current.querySelectorAll("tbody tr");
    if (rows.length < 11) {
      setMaxHeight(null);
      return;
    }

    let rowsHeight = 0;
    for (let i = 0; i < Math.min(10, rows.length); i++) {
      rowsHeight += rows[i].offsetHeight;
    }

    setMaxHeight(theadHeight + rowsHeight)
  }, [tableRef, items, hasResultOk]);

  return maxHeight
};

export default useTableInspectionItemsScroll;